<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Produk</h1>
            
          </div>
        <div class="section-body">
            <h2 class="section-title">Buat Produk</h2>
            <p class="section-lead">Buat produk jika produk yang diinginkan tidak ditemukan di daftar produk.</p>

            <div class="row">
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Utama</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>* Nama Produk</label>
                                <input type="text" v-model="nama_produk" required class="form-control">
                            </div>
                            <div class="form-group mb-0">
                                <label>Deskripsi</label>
                                <textarea class="form-control" v-model="deskripsi" ></textarea>
                            </div>
                            <div class="form-group">
                                <label>Kode Produk</label>
                                <input type="text" v-model="kode_produk" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Satuan</label>
                                <select id="satuan" class="form-control select2">
                                    <option v-for="option in satuanList" v-bind:key="option.id_satuan" :value="option.id_satuan" >{{ option.nama_satuan}} </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Kategori Produk</label>
                                <select id="kategori" class="form-control select2" multiple="">
                                    <option v-for="option in kategoriList" v-bind:key="option.id_kategori_produk" :value="option.id_kategori_produk" >{{ option.nama_kategori_produk}} </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="(a, index) in alias" v-bind:key="index" class="col-12 col-md-4 col-lg-4">
                    <div class="card" style="height:582px;">
                        <div class="card-header">
                            <h4>Informasi Alias {{ a.nama_alias }}</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>* Nama Produk</label>
                                <input type="text" v-model="a.nama_alias" class="form-control">
                            </div>
                            <div class="form-group mb-0">
                                <label>Deskripsi</label>
                                <textarea class="form-control" v-model="a.deskripsi_alias"></textarea>
                            </div>
                            <div class="form-group">
                                <label>Kode Produk</label>
                                <input type="text" v-model="a.kode_alias" class="form-control">
                            </div>
                            
                            <!-- <div style="margin-top:24%;">
                                &nbsp;
                            </div> -->
                            <div class="form-group">
                                <button class="btn btn-warning" @click="removeAlias(index,a.nama_alias)"><i class="fas fa-times"></i> Hapus Alias</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="text-align:center;padding:10%;" class="col-12 col-md-4 col-lg-4">
                     <span style="cursor:pointer;" @click="addAlias()" class="fa-stack fa-5x">
                        <i class="fa fa-circle fa-stack-2x"></i>
                        <i class="fa fa-plus fa-stack-1x fa-inverse"></i>
                    </span>
                    <div>
                        Tambah Alias
                    </div>
                </div>
                <div v-if="col == 0" style="text-align:center;padding:10%;" class="col-12 col-md-4 col-lg-4">
                    <div>
                        &nbsp;
                    </div>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Harga Beli / Produksi</h4>
                            <div class="form-group" style="margin-bottom:0px;">
                                <div class="selectgroup w-100">
                                    <label class="selectgroup-item" style="margin-bottom:0px;">
                                        <input type="radio" value="beli" v-model="jenis_beli" class="selectgroup-input" checked>
                                    <span class="selectgroup-button">Beli</span>
                                    </label>
                                    <label class="selectgroup-item" style="margin-bottom:0px;">
                                        <input type="radio" value="produksi" v-model="jenis_beli" class="selectgroup-input">
                                    <span class="selectgroup-button">Produksi</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div v-if="jenis_beli == 'beli'" class="card-body">
                            <div class="form-group">
                                <label>Harga Beli Satuan</label>
                                <input type="text" v-model="harga_beli" v-if="renderHarga" v-imask="mask" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Akun Pembelian</label>
                                <select id="akun_beli" class="form-control select2">
                                    <option v-for="option in akunBeliList" v-bind:key="option.id_coa" :value="option.id_coa">({{option.kode_akun}}) - {{ option.nama_akun}} ({{option.deskripsi}})</option>
                                </select>
                            </div>
                        </div>
                        <div v-if="jenis_beli == 'produksi'" class="card-body">
                            <div class="table-responsive">
                                <label>Terdiri Dari</label>
                                <table v-if="bodyRender" class="table table-striped table-md">
                                    <tr>
                                        <th>Produk</th>
                                        <th>Kuantitas</th>
                                        <th>Perkiraan Biaya</th>
                                        <th></th>
                                    </tr>
                                    <tr v-for="(option,index) in bahanProduksiList" v-bind:key="option.id_produk_bahan">
                                        <td>
                                            <div class="form-group">
                                                <v-select :id="'bahan_'+index" v-model="bahanProduksiList[index].val" :reduce="text => text.value" :value="bahanProduksiList[index].val" :options="bahanList" label="text" @input="countPerkiraan(index)"></v-select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <div class="input-group">
                                                    <input type="number" @change="countPerkiraan(index)" class="form-control" v-model="option.qty">
                                                    <div class="input-group-append">
                                                        <div class="input-group-text">
                                                            <i>{{ option.nama_satuan }}</i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>Rp. {{ currencyFormat(option.perkiraan_biaya) }}</td>
                                        <td> <i @click="deleteBahanProduksi(index)" style="font-size:18px;cursor:pointer;color:red;" class="fa fa-times"></i>  </td>
                                    </tr>
                                    <tr>
                                        <th style="text-align:right" colspan="2">Total Perkiraan</th>
                                        <th>Rp. {{ currencyFormat(total_perkiraan) }}</th>
                                    </tr>
                                    <tr>
                                        <td style="cursor:pointer;padding-top:40px;" @click="addItem()">
                                            <strong>+ Tambah Data</strong>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Harga Jual</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>Harga Jual Satuan</label>
                                <input type="text" v-if="renderHarga" v-model="harga_jual" v-imask="mask" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Akun Penjualan</label>
                                <select id="akun_jual" class="form-control select2">
                                       <option v-for="option in akunJualList" v-bind:key="option.id_coa" :value="option.id_coa">({{option.kode_akun}}) - {{ option.nama_akun}} ({{option.deskripsi}})</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button v-if="type=='new'" @click="submit('normal')" class="btn btn-primary">Buat Produk</button>
                    <button v-if="type=='edit'" @click="submit('normal')" class="btn btn-primary">Update Produk</button>
                    <button v-if="type=='new'" @click="submit('next')" class="btn btn-info">Buat Produk & Buat Lagi</button>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<style>
.vs__dropdown-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: flex;
    padding: 7px 4px 7px 4px;
    background: none;
    border: 1px solid #e4e6fc;
    border-radius: 4px;
    white-space: normal;
    min-width: 360px;
}
.vs__actions {
    padding: 0px 6px 0 3px;
}
.vs__clear {
    display:none;
}
.vs__dropdown-menu {
    background-color: white;
    border: 1px solid #aaa;
    border-radius: 4px;
    box-sizing: border-box;
    display: block;
    position: absolute;
    z-index: 3000;
    max-height: 120px !important;
}
</style>

<script>
import Vue from 'vue'
import {IMaskDirective} from 'vue-imask';
import vSelect from 'vue-select'
import { parse } from 'path';
Vue.component('v-select', vSelect)

export default {
    data() {
        return {
            nama_produk: '',
            deskripsi: '',
            kode_produk: '',
            satuan: '',
            kategori: [],
            alias : [],
            harga_beli : '',
            harga_jual : '',
            akun_beli : '',
            akun_jual : '',
            col : '',
            satuanList : [],
            kategoriList : [],
            akunList: [],
            akunBeliList: [],
            akunJualList: [],
            mask: {
                mask: Number,
                thousandsSeparator: '.',
                normalizeZeros: false,
            },
            jenis_beli: 'beli',
            bahanProduksiList : [],
            bahanList : [],
            test: '',
            type : 'new',
            produkDetail : [],
            id_produk : '',
            renderHarga : true,
            bodyRender : true,
        }
    },
    mounted() {
        this.init();
        window.$(document).ready(function(){
            setTimeout(function(){ 
                $("#satuan").select2();
                $("#kategori").select2(); 
                $("#akun_jual").select2(); 
                $("#akun_beli").select2(); 
            }, 100);
            
        });
    },
    methods: {
        init: function() {
            // get kategori list
            this.$root.is_loading = !this.$root.is_loading;
			this.$http.post("Datalist/getKategoriProduk").then(result => {
			    if(result.data.code == '00') {
                    alert('failed get kategori')
                }
                else {
                    this.kategoriList = result.data.detail
                }
			}, error => {
				console.log('gk ok')
				context.errors = errors;
            });
            
            // get satuan list
			this.$http.post("Datalist/getSatuan").then(result => {
			    if(result.data.code == '00') {
                    alert('failed get satuan')
                }
                else {
                    this.satuanList = result.data.detail
                }
			}, error => {
				console.log('gk ok')
				context.errors = errors;
            });
            
            // get coa/akun list
			this.$http.post("Datalist/getCoa").then(result => {
			    if(result.data.code == '00') {
                    alert('failed get coa')
                }
                else {
                    this.akunList = result.data.detail
                    this.akunBeliList = this.filterArr(this.akunList,'id_kategori','15')
                    this.akunJualList = this.filterArr(this.akunList,'id_kategori','13')
                }
			}, error => {
				console.log('gk ok')
				context.errors = errors;
            });

            //get bahan
            this.$http.post("Produk/getBahan").then(result => {
                if(result.data.code == '00'){
                    console.log('bahan empty')
                }else {
                    this.bahanProduksiList = result.data.detail
                }
            })

            //get bahan list
            this.$http.post("Produk/getBahanListProduk").then(result => {
                if(result.data.code == '00'){
                    console.log('bahan list empty')
                }else {
                    this.bahanList = result.data.detail
                }
                this.$root.is_loading = !this.$root.is_loading;
            })

            // get Produk detail
            if(this.$route.params.id_produk != null) {
                this.type = 'edit'
                this.id_produk = this.$route.params.id_produk
                this.$http.post("Produk/getProdukDetail/"+this.id_produk).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Detail')
                    }
                    else {
                        this.produkDetail = result.data.detail
                        this.nama_produk = this.produkDetail.detail.nama_produk
                        this.kode_produk = this.produkDetail.detail.kode_produk
                        this.deskripsi = this.produkDetail.detail.deskripsi_produk
                        this.alias  = this.produkDetail.alias
                        this.col = (this.alias.length + 1) % 3
                        this.satuan = this.produkDetail.detail.id_satuan
                        this.harga_beli = this.produkDetail.detail.harga_beli
                        if(this.harga_beli == null){
                            this.harga_beli = ''
                        }
                        this.harga_jual = this.produkDetail.detail.harga_jual
                        if(this.harga_jual == null){
                            this.harga_jual = ''
                        }
                        this.akun_jual = this.produkDetail.detail.akun_jual
                        this.akun_beli = this.produkDetail.detail.akun_beli
                        this.renderHarga = false
                        this.$nextTick(() => {
                            this.renderHarga = true
                        });
                        if(this.produkDetail.detail.is_produksi == 1){
                            this.jenis_beli = 'produksi'
                        }
                        var sat = parseInt(this.satuan);
                        var aj = parseInt(this.akun_jual);
                        var ab = parseInt(this.akun_beli);
                        var kt = []
                        this.produkDetail.kategori.forEach(function(item,index){
                            kt.push(item.id_kategori_produk)
                        });
                        this.kategori = kt

                        setTimeout(function(){ 
                            $("#satuan").val(sat).trigger('change');
                            $("#kategori").val(kt).trigger('change'); 
                            $("#akun_jual").val(aj).trigger('change'); 
                            $("#akun_beli").val(ab).trigger('change'); 
                        }, 200);
                        if(this.produkDetail.detail.is_produksi == "1"){
                            this.$http.post("Produk/getBahan/"+this.id_produk).then(result => {
                                if(result.data.code == '00') {
                                    alert('failed get bahan list')
                                }
                                else {
                                    this.bahanProduksiList = result.data.detail
                                }
                            }, error => {
                                console.log('gk ok')
                                context.errors = errors;
                            });
                        }
                        console.log(this.produkDetail);
                    }
                }, error => {
                    console.log('gk ok')
                    context.errors = errors;
                });
            }


            
        },
        addAlias: function() {
            for (var i = 0; i < this.alias.length; i++) {
					if (this.alias[i].nama_produk == "") {
							this.$parent.toastr = {
                                title : 'Warning',
                                message: 'Ada nama alias belum terisi !',
                                type : 'warning'
                            }
							return false;
					}
			}
			this.alias.push({
					nama_alias: '',
                    deskripsi_alias: this.deskripsi,
                    kode_alias: this.kode_produk
            });
            this.col = (this.alias.length + 1) % 3
        },
        removeAlias: function(index, nama_produk) {
            let confirm = window.confirm("Kamu yakin ingin menghapus Alias "+nama_produk+"?");
            if (confirm) {
                this.alias.splice(index, 1);
                this.col = (this.alias.length + 1) % 3
			}
        },
        setSatuan: function(){
            // this.satuan = $("#satuan").select2('val')
            // console.log(this.satuan)
        },
        setKategori: function(){
            // this.kategori = $("#kategori").select2('val')
            // console.log(this.kategori)
        },
        submit: function(type) {
            
            this.satuan = $("#satuan").select2('val')
            this.kategori = $("#kategori").select2('val')
            this.akun_beli = $("#akun_beli").select2('val')
            this.akun_jual = $("#akun_jual").select2('val')
            
            if(this.nama_produk == '') {
                this.$parent.toastr = {
                    title : 'Error',
                    message: 'Nama produk harus diisi !',
                    type : 'error'
                }
                return false
            }

            var formsub = new FormData();
            var objThis = this;
            formsub.append('type',this.type)
            if(this.type == 'edit') {
                formsub.append('id_produk',this.id_produk)
            }
            formsub.append('nama_produk',this.nama_produk);
            formsub.append('deskripsi',this.deskripsi);
            formsub.append('kode_produk', this.kode_produk);
            formsub.append('satuan',this.satuan);
            if(this.kategori.length > 0){
                $.map(objThis.kategori, function(value,index){
                    formsub.append('kategori['+index+']', value);
                });
            }
            if(this.alias.length > 0){
                $.map(objThis.alias, function(value,index){
                    formsub.append('alias['+index+'][nama_produk]', value.nama_alias);
                    formsub.append('alias['+index+'][deskripsi]', value.deskripsi_alias);
                    formsub.append('alias['+index+'][kode_produk]', value.kode_alias);
                });
            }
            formsub.append('jenis_beli',this.jenis_beli);
            if(this.jenis_beli == 'produksi'){
                $.map(objThis.bahanProduksiList, function(value,index){
                    if(value.id_produk_bahan == ''){
                        this.$parent.toastr = {
                            title : 'Error',
                            message: 'Ada bahan produksi belum terisi !',
                            type : 'error'
                        }
                        return false
                    }
                    formsub.append('bahanProduksi['+index+'][id_produk_bahan]', value.id_produk_bahan);
                    formsub.append('bahanProduksi['+index+'][qty]', value.qty);
                    formsub.append('bahanProduksi['+index+'][perkiraan_biaya]', value.perkiraan_biaya);
                });
            }else{
                formsub.append('harga_beli',this.harga_beli.replace(/\./g, ""));
                formsub.append('akun_beli',this.akun_beli);
            }

            formsub.append('harga_jual',this.harga_jual.replace(/\./g, ""));
            formsub.append('akun_jual',this.akun_jual);

          
            this.$http.post("Produk/updateProduk", formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Data produk telah terupdate !',
                        type : 'success'
                    }
                    if(type == 'normal'){
                        this.$router.replace({ path : '/produk/daftar-produk' })
                        
                    }else {
                        this.$parent.reRendering(); 
                    }
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Gagal update produk !',
                        type : 'error'
                    }          
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        },
        filterArr: function(array,prop,value) {
            var filtered = [];
            for(var i = 0; i < array.length; i++){
                if(array[i][prop] == value){
                    filtered.push(array[i])
                }
            }    
            return filtered;
        },
        formatBeli: function(val){
          this.harga_beli = this.currencyFormat(val)  
        },
        formatJual: function(val){
          this.harga_jual = this.currencyFormat(val)  
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        addItem: function() {
            for (var i = 0; i < this.bahanProduksiList.length; i++) {
					if (this.bahanProduksiList[i].id_produk_bahan == "" || this.bahanProduksiList[i].qty == "") {
							this.$parent.toastr = {
                                title : 'Warning',
                                message: 'Ada bahan / qty belum terisi !',
                                type : 'warning'
                            }
							return false;
					}

			}
			this.bahanProduksiList.push({
                    id_produk_bahan: '',
                    val: '',
                    qty: 0,
                    nama_satuan: '',
					perkiraan_biaya: 0,
			});
			this.$nextTick(function(){
                document.getElementById('bahan_'+i).focus();
            })
        },
        getPerkiraanBiaya(id,index) {
            this.bahanProduksiList[index].perkiraan_biaya = priceBahan * this.bahanProduksiList[index].qty 
            $("#"+id).select2("destroy")
            $("#"+id).select2()
        },
        countPerkiraan(index){
            console.log('kevin ganteng');
            var val = this.bahanProduksiList[index].val.split("|")
            this.bahanProduksiList[index].id_produk_bahan = val[0]
            var priceBahan = val[1]
            this.bahanProduksiList[index].nama_satuan = val[2]
            this.bahanProduksiList[index].perkiraan_biaya = priceBahan * this.bahanProduksiList[index].qty;
        },
        MoneyCallback(x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        deleteBahanProduksi: function(index)
        {
            if(!confirm('Apakah kamu yakin mau menghapus bahan ini?'))
            {
                return false;
            }

            this.$parent.toastr = {
                title : 'Success',
                message: 'Bahan '+this.bahanProduksiList[index].kode_produk+' | '+this.bahanProduksiList[index].nama_produk+' berhasil dihapus !',
                type : 'success'
            }
            this.$nextTick(function(){
                this.bahanProduksiList.splice(index, 1);
                this.bodyRender = false
                this.$nextTick(function(){
                    this.bodyRender = true
                })
            })
            
        }
    },
    directives: {
      imask: IMaskDirective
    },
    components: {

    },
    watch: {
        jenis_beli: function(){
            if(this.jenis_beli == 'beli')
            {
                this.$nextTick(() => {
                    $("#akun_beli").select2()
                });
            }
        },
        bahanProduksiList: {
            handler: function(values,oldValues){
                // console.log(values);
                // console.log(oldValues);
                // const ind = values.findIndex(function (v, i){ 
                //     return v != oldValues[i]
                //     console.log(v);
                //     console.log(i);
                //     console.log(oldValues[i])
                //     if(v !== oldValues[i]){
                //         console.log(i);
                //         return i
                //     }
                // })

                // console.log(ind);

                // const index = values.findIndex(function (v, i) { return v !== oldValues[i] })
                // console.log(values[index], index)
                // var val = this.bahanProduksiList[index].val.split("|")
                // this.bahanProduksiList[index].id_produk_bahan = val[0]
                // var priceBahan = val[1]
                // this.bahanProduksiList[index].perkiraan_biaya = priceBahan * this.bahanProduksiList[index].qty;
            },
            deep: true,
        }
    },
    computed: {
        total_perkiraan : function(){
            var totals = 0;
            this.bahanProduksiList.forEach(function(item, index){
                totals = parseFloat(item.perkiraan_biaya) + totals
            })
            return totals
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/produk/BuatProduk.vue